import Loc from "../../../Loc/Loc";
import MyModal from "./MyModal";
import { define_button_className } from "./MyModal";
import { define_button_text } from "./MyModal";

interface ExternalDocModalProps {
    externalDoc: any;
    recep: boolean;
}

export default function ExternalDocModal(props: ExternalDocModalProps) {;
    const width: string = props.recep ? "110px" : "90px";

    return (
        <MyModal
            className={props.recep ? "btn btn-fives btn-sm" : define_button_className(props.externalDoc.state)}
            style={{ padding: "4px", width: width, color: "white", marginLeft: "14px" }}
            textButton={props.recep ? Loc.trad().ExternalDocModalReceive : define_button_text(props.externalDoc.state)}
            disabled={!props.recep}
            element={"externalDocModal"}
            externalDoc={props.externalDoc}
        ></MyModal>
    )
}